









































































































import {
  ref,
  defineComponent,
  computed,
  useRouter,
  useContext,
  useFetch,
} from "@nuxtjs/composition-api";
import { useUserOrder } from "~/modules/customer/composables/useUserOrder";
import { CustomerOrderListResults } from "~/modules/customer/composables/useUserOrder/useUserOrder";
import { useCustomerStore } from "~/modules/customer/stores/customer";
import { convertTime } from "~/helpers";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import Pagination from "~/modules/customer/pages/MyAccount/Pagination.vue";
import { useUiNotification } from "~/composables";
import { useUiHelpers } from "~/composables/useUiHelpers";

export default defineComponent({
  name: "OrderHistory",
  components: {
    SkeletonLoader,
    Pagination
  },
  setup() {
    const router = useRouter();
    const { app } = useContext();
    const { listOrderByFilter, error, loading } = useUserOrder();
    const { user } = useCustomerStore();
    const { send: sendNotification } = useUiNotification();
    const { changePage } = useUiHelpers();

    const phoneLogin = computed(() => user?.phone_number);
    const customerId = computed(() => user?.customer_id);
    const orders = ref<CustomerOrderListResults | null>(null);
    const totalOrder = ref(0);
    const currentPage = ref(1);
    const itemsPerPage = 10;
    const loadedPages = ref<Record<number, CustomerOrderListResults>>({});

    const totalPages = computed(() => {
      return Math.ceil(totalOrder.value / itemsPerPage);
    });

     useFetch(async () => {
      let routerQuery;
      if (process?.client) {
        routerQuery = router?.resolve(
          (window?.location?.pathname + window?.location?.search)?.slice(1)
        )?.route?.query;
      } else {
        routerQuery = router?.currentRoute?.query;
      }

      currentPage.value = parseInt(routerQuery?.page) || 1;

      if (phoneLogin.value && customerId.value) {
        const params = {
          phone_number: phoneLogin.value,
          customerId: customerId.value,
          limit: itemsPerPage,
          offset: itemsPerPage * (currentPage.value - 1),
        };
        orders.value = await listOrderByFilter(params);
        totalOrder.value = orders.value?.total_count || 0;
        if (orders.value) {
          loadedPages.value[currentPage.value] = orders.value;
        }
      }
    });

    const loadOrderByPage = async (page) => {
      if (phoneLogin.value && customerId.value) {
        if (loadedPages.value[page]) {
          orders.value = loadedPages.value[page];
          return;
        }

        const params = {
          phone_number: phoneLogin.value,
          customerId: customerId.value,
          limit: itemsPerPage,
          offset: itemsPerPage * (page - 1),
        };
        orders.value = await listOrderByFilter(params);

        if (orders.value) {
          loadedPages.value[page] = orders.value;
        }
      }
    };
   
    const goToPage = (page) => {
      if (page !== currentPage.value && page > 0 && page <= totalPages.value) {
        currentPage.value = page;
        loadOrderByPage(page);
        changePage(page, false);
      }
    };

    const changeTime = (time) => {
      return convertTime(time);
    };

    const checkOrderStatus = (status, payment_method, type = "status") => {
      switch (status) {
        case "Created":
          if (type == "status") {
            return "Đang xử lý";
          }

          return "processing";
        case "Validated":
          if (type == "status") {
            return "Đang xử lý";
          }

          return "processing";
        case "To be Prepared":
          if (type == "status") {
            return "Đang vận chuyển";
          }

          return "processing";
        case "Ready for pickup":
          if (type == "status") {
            return "Đã có hàng";
          }

          return "processing";
        case "Prepared":
          if (type == "status") {
            return "Đang vận chuyển";
          }

          return "shipping";
        case "Package given to carrier":
          if (type == "status") {
            return "Đã giao";
          }

          return "delivered";
        case "complete":
          if (type == "status") {
            return "Đã giao";
          }

          return "delivered";
        case "Cancel":
          if (type == "status") {
            return "Đã hủy";
          }

          return "cancel";
        case "Pending":
          if (type == "status") {
            if (payment_method !== "cashondelivery") {
              return "Chờ thanh toán";
            } else {
              return "Đang xử lý";
            }
          } 
        default:
          if (type == "status") {
            return "Đang xử lý";
          }

          return "Đang xử lý";
      }
    };

    const getStatusClass = (status, payment_method) => {
      switch (status) {
        case "Created":
          return "order-item__status--waiting";
        case "Validated":
        case "To be Prepared":
          return "order-item__status--processing";
        case "Processing":
          return "order-item__status--processing";
        case "Prepared":
          return "order-item__status--shipping";
        case "Package given to carrier":
        case "complete":
          return "order-item__status--delivered";
        case "Cancel":
          return "order-item__status--cancel";
        case "Pending":
          if (payment_method !== "cashondelivery") {
            return "order-item__status--waiting";
          } else {
            return "order-item__status--processing";
          }
        default:
          return "";
      }
    };

    const gotoDetail = (order) => {
      if (!order || !order.increment_id) {
        return;
      }
      const routerOrderDetail = app.localeRoute({
        name: "customer-single-order",
        params: {
          orderId: order.increment_id,
        },
      });
      router.push(routerOrderDetail);
    };

    const copyText = async (code) => {
      try {
        await navigator.clipboard.writeText(code);

        sendNotification({
          id: Symbol("coppy-order-history-id"),
          message: `Bạn đã copy mã ${code}`,
          type: "success",
          icon: "",
          persist: false,
        });
      } catch (err) {
        console.error("Lỗi khi sao chép:", err);
      }
    };

    const getElapsedDays = (dateString) => {
      if (!dateString) return 0;

      const orderDate = new Date(dateString);
      const currentDate = new Date();
      const diffTime = Math.abs(currentDate.getTime() - orderDate.getTime());
      const diffDays = Math.floor(diffTime / (24 * 60 * 60 * 1000));
      return diffDays;
    };

    return {
      changeTime,
      orders,
      error,
      checkOrderStatus,
      loading,
      gotoDetail,
      getStatusClass,
      totalOrder,
      loadOrderByPage,
      currentPage,
      totalPages,
      goToPage,
      copyText,
      getElapsedDays,
      itemsPerPage,
    };
  },
});
